import ky from 'ky';

import { Config } from 'src/config';

const prefixUrl = Config.backendServer;

/** ky's own default, restated here so the value we opt out of is visible. */
export const DEFAULT_TIMEOUT_MS = 10000;

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]', '::1', '0.0.0.0']);

/**
 * Whether the backend is this machine.
 *
 * A malformed or missing URL counts as remote: the timeout is a safety net, and an
 * unparseable value is no reason to remove it.
 */
export const isLocalBackendUrl = (url: string | undefined): boolean => {
    let isLocal = false;

    if (url) {
        try {
            const { hostname } = new URL(url);
            isLocal = LOCAL_HOSTNAMES.has(hostname) || hostname.endsWith('.localhost');
        } catch {
            isLocal = false;
        }
    }

    return isLocal;
};

/**
 * Bare minimum setup needed to send a request to our backend server.
 *
 * Against a local backend the timeout is off entirely. A debugger breakpoint, a cold
 * import or a slow query on a dev machine routinely outlasts ten seconds, and ky
 * aborting the request mid-step reports it as a network failure — which sends you
 * hunting for a frontend bug that isn't there. Deployed environments keep the timeout,
 * where a request that hangs that long is a real fault worth surfacing.
 */
export const simpleKy = ky.create({
    prefixUrl,
    timeout: isLocalBackendUrl(prefixUrl) ? false : DEFAULT_TIMEOUT_MS,
});
